// constants
import { DashboarPageActionTypes } from './constants';

export interface DashboarPageActionType<TPayload> {
    type:
    DashboarPageActionTypes.CHANGE_FILTERMENU_ADD_SUCCESS
    | DashboarPageActionTypes.CHANGE_FILTERMENU_ADD
    |DashboarPageActionTypes.CHANGE_FILTERMENU_EDIT
    | DashboarPageActionTypes.CHANGE_FILTERMENU_DELETE
    | DashboarPageActionTypes.CHANGE_CHARTS_COPY
    | DashboarPageActionTypes.CHANGE_CHARTS_VIEW
    | DashboarPageActionTypes.CHANGE_CHARTS_COPY_SUCCESS
    | DashboarPageActionTypes.CHANGE_CHARTS_DELETE_FROMPAGE
    | DashboarPageActionTypes.CHANGE_CHARTS_UPDATE_FROMPAGE
    | DashboarPageActionTypes.CHANGE_LAYOUT_UPDATE_FROMPAGE    
    | DashboarPageActionTypes.CHANGE_CHARTS
    | DashboarPageActionTypes.CHANGE_CHART_DATA
    | DashboarPageActionTypes.CHANGE_CHARTLAYOUTS    
    | DashboarPageActionTypes.CHANGE_CHARTS_SHOWBTNONHOVER
    | DashboarPageActionTypes.CHANGE_CHARTS_FILTER
    | DashboarPageActionTypes.CHANGE_CHARTS_DIM
    | DashboarPageActionTypes.CHANGE_CHARTS_LOCATION    
    | DashboarPageActionTypes.CHANGE_CHARTS_GET
    | DashboarPageActionTypes.CHANGE_PUBLICSHARE_CHARTS_GET    
    | DashboarPageActionTypes.CHANGE_CHARTS_GET_LOAD
    | DashboarPageActionTypes.CHANGE_FILTERMENUDATA
    | DashboarPageActionTypes.CHANGE_FILTERMENULIST
    | DashboarPageActionTypes.CHANGE_FILTERMENULIST_GET
    | DashboarPageActionTypes.CHANGE_PUBLICFILTERMENULIST_GET    
    | DashboarPageActionTypes.CHANGE_FILTERMENULIST_GET_LOAD
    | DashboarPageActionTypes.CHANGE_FILTERMENUVALUE
    | DashboarPageActionTypes.CHANGE_DRILLVALUE
    | DashboarPageActionTypes.CHANGE_DRILLFILTERVALUE
    | DashboarPageActionTypes.CHANGE_CHARTTYPEDASH
    | DashboarPageActionTypes.CHANGE_IS_SLIDESHOW
    | DashboarPageActionTypes.CHANGE_IS_SLIDESHOWPAUSE
    | DashboarPageActionTypes.CHANGE_IS_CHANGELAYOUT

    payload?: TPayload;
}

export const changeChartsLocationAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_LOCATION,
    payload: layout,
});

export const changeChartsGetAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_GET,
    payload: layout,
});

export const changePublicShareChartsGetAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_PUBLICSHARE_CHARTS_GET,
    payload: layout,
});



export const changeChartsAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS,
    payload: layout,
});

export const changeChartsLoadAction = (): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_GET_LOAD,    
});



export const changeChartLayoutAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTLAYOUTS,
    payload: layout,
});

export const changeChartDataPageAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHART_DATA,
    payload: layout,
});

export const changeChartsShowBtnOnHideAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_SHOWBTNONHOVER,
    payload: layout,
});

export const changeChartsFilterAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_FILTER,
    payload: layout,
});

export const changeChartsDimAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_DIM,
    payload: layout,
});


export const changeCopyChartsAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_COPY,
    payload: layout,
});

export const changeViewChartsAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_VIEW,
    payload: layout,
});

export const changeCopyChartsSuccessAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_COPY_SUCCESS,
    payload: layout,
});

export const changeDeleteChartsFromPageAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_DELETE_FROMPAGE,
    payload: layout,
});

export const changeUpdateChartsFromPageAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTS_UPDATE_FROMPAGE,
    payload: layout,
});

export const changeUpdateLayoutFromPageAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_LAYOUT_UPDATE_FROMPAGE,
    payload: layout,
});

export const changeFlterAddAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_FILTERMENU_ADD,
    payload: layout,
});

export const changeFlterEditAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_FILTERMENU_EDIT,
    payload: layout,
});

export const changeFlterDeleteAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_FILTERMENU_DELETE,
    payload: layout,
});



export const changeFlterAddSuccessAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_FILTERMENU_ADD_SUCCESS,
    payload: layout,
});

export const changeFilterMenuListAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_FILTERMENULIST,
    payload: layout,
});

export const changeFilterMenuDataAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_FILTERMENUDATA,
    payload: layout,
});

export const changeFilterMenuListGetAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_FILTERMENULIST_GET,
    payload: layout,
});

export const changePublicFilterMenuListGetAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_PUBLICFILTERMENULIST_GET,
    payload: layout,
});

export const changeFilterMenuListGetLoadAction = (): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_FILTERMENULIST_GET_LOAD,    
});


export const changeFilterMenuValueAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_FILTERMENUVALUE,
    payload: layout,
});

export const changeDrillValueAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_DRILLVALUE,
    payload: layout,
});

export const changeDrillFilterValueAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_DRILLFILTERVALUE,
    payload: layout,
});

export const changeChartTypeDashAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_CHARTTYPEDASH,
    payload: layout,
});

export const changeIsSlideShowAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_IS_SLIDESHOW,
    payload: layout,
});

export const changeIsSlideShowPauseAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_IS_SLIDESHOWPAUSE,
    payload: layout,
});

export const changeIsChangeLayoutAction = (layout: any): DashboarPageActionType<any> => ({
    type: DashboarPageActionTypes.CHANGE_IS_CHANGELAYOUT,
    payload: layout,
});


